import { withMotion } from '../hoc/with-motion';
import { OrgPodcastList } from '@/modules/manager/components/org/podcast-list';

const AnimatedPage = withMotion(OrgPodcastList);

export const roles: string[] = [];
export const path = '/manager/:orgId/hosting';
export const element = <AnimatedPage />